export const BANKS_CONSTS = {
    GET_BANKS: "GET_BANKS",
    CREATE_BANK: "CREATE_BANK",
    UPDATE_BANK: "UPDATE_BANK",
    DELETE_BANK_BY_ID: "DELETE_BANK_BY_ID",
};
